import { authHeader, config } from '_helpers';
import axios from 'axios';

export const profileService = {
  fetchDropdownData,
  getUser,
  updateProfile,
  getTrainingData,
  getInventoryAssignedData,
  getEmploymentHistoryData,
};

async function fetchDropdownData() {
  const { data } = await axios.get(config.apiUrl + '/api/getlistprofile');
  return data;
}

async function getTrainingData(userId) {
  const { data } = await axios.get(
    `${config.apiUrl}/api/employee/training/content/${userId}`,
    { headers: authHeader() }
  );
  return data;
}

async function getInventoryAssignedData(hash) {
  let formData = new FormData();
  formData.append('hash', hash);
  const { data } = await axios.post(
    `${config.apiUrl}/api/inventory/getcrewmemberlist`,
    formData,
    { headers: authHeader() }
  );
  return data;
}

async function getEmploymentHistoryData(userId) {
  const { data } = await axios.get(
    `${config.apiUrl}/api/employee/${userId}/employment-history`,
    { headers: authHeader() }
  );
  return data;
}

async function getUser(hash) {
  if (!hash || hash == undefined) {
    return;
  }

  const { data } = await axios.get(config.apiUrl + '/api/user?hash=' + hash, {
    headers: authHeader(),
  });
  return data;
}

async function updateProfile(userId, formData) {
  return axios.post(
    config.apiUrl + '/api/employee/' + userId + '/save',
    formData,
    { headers: authHeader() }
  );
}
